var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fp_qty" }, [
    _c("span", { staticClass: "fp_qty__dec", on: { click: _vm.decrement } }),
    _vm._v(" "),
    _c("input", {
      staticClass: "fp_qty__input",
      attrs: { type: "number", min: _vm.min },
      domProps: { value: _vm.value },
      on: { input: _vm.updateValue },
    }),
    _vm._v(" "),
    _c("span", { staticClass: "fp_qty__inc", on: { click: _vm.increment } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }